export function escapeRegex(string: string): string {
    return string.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
}

export function sumArray(array: number[]) {
    if (!(array instanceof Array)) return 0;
    let sum = 0;
    array.forEach(v => sum = sum + v);
    return sum;
}
